import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorksManufacturedMaterials(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIALS,
		options
	)
}
function _getDoneWorksManufacturedMaterialPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIAL_PREVIEW,
		options
	)
}
function _getDoneWorksManufacturedMaterialPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIAL_POPUP,
		options
	)
}

function _createDoneWorksManufacturedMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].CREATE_DONE_WORKS_MANUFACTURED_MATERIAL,
		options
	)
}

function _getDoneWorksManufacturedMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIAL,
		options
	)
}

function _patchDoneWorksManufacturedMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].PATCH_DONE_WORKS_MANUFACTURED_MATERIAL,
		options
	)
}

function _putDoneWorksManufacturedMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].PUT_DONE_WORKS_MANUFACTURED_MATERIAL,
		options
	)
}

function _deleteDoneWorksManufacturedMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].DELETE_DONE_WORKS_MANUFACTURED_MATERIAL,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIALS]: _getDoneWorksManufacturedMaterials,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIAL_PREVIEW]: _getDoneWorksManufacturedMaterialPreview,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIAL_POPUP]: _getDoneWorksManufacturedMaterialPopup,

	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].CREATE_DONE_WORKS_MANUFACTURED_MATERIAL]: _createDoneWorksManufacturedMaterial,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].GET_DONE_WORKS_MANUFACTURED_MATERIAL]: _getDoneWorksManufacturedMaterial,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].PATCH_DONE_WORKS_MANUFACTURED_MATERIAL]: _patchDoneWorksManufacturedMaterial,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].PUT_DONE_WORKS_MANUFACTURED_MATERIAL]: _putDoneWorksManufacturedMaterial,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS].DELETE_DONE_WORKS_MANUFACTURED_MATERIAL]: _deleteDoneWorksManufacturedMaterial,
}